import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PainSolution } from "@/components/landing/PainSolution";
import { Solutions } from "@/components/landing/Solutions";
import { Methodology } from "@/components/landing/Methodology";
import { Team } from "@/components/landing/Team";
import { Metrics } from "@/components/landing/Metrics";
import { LegalSecurity } from "@/components/landing/LegalSecurity";
import { FlexibleModel } from "@/components/landing/FlexibleModel";
import { Differentials } from "@/components/landing/Differentials";
import { AboutPrevisa } from "@/components/landing/AboutPrevisa";
import { FAQ } from "@/components/landing/FAQ";
import { CTAFinal } from "@/components/landing/CTAFinal";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { usePageSEO } from "@/hooks/useCanonical";

const HOME_TITLE =
  "Previsa Saúde — Entrevista Médica Qualificada para Operadoras de Saúde";
const HOME_DESC =
  "Entrevista médica qualificada, análise de Declaração de Saúde, gestão de CPT e parecer técnico para operadoras e administradoras de planos de saúde. São 6.000 entrevistas por mês.";

export default function LandingPage() {
  usePageSEO({ path: "/", title: HOME_TITLE, description: HOME_DESC });
  return (
    <main data-testid="landing-page" className="bg-white text-[#1F2937]">
      <Header />
      <Hero />
      <PainSolution />
      <Solutions />
      <Methodology />
      <Team />
      <Metrics />
      <LegalSecurity />
      <FlexibleModel />
      <Differentials />
      <AboutPrevisa />
      <FAQ />
      <CTAFinal />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
